<template>
  <div class="social-step-editor-sidebar-media-images">
    <shared-step-editor-input-field
      :input-value="search"
      :height="40"
      label="Label"
      placeholder="Search millions of images"
      class="social-step-editor-sidebar-media-images__search"
      @input="onSearch"
    >
      <template v-slot:prefix>
        <span v-html="icon" class="social-step-editor-sidebar-media-images__icon"></span>
      </template>
    </shared-step-editor-input-field>
    <p class="social-step-editor-sidebar-media-images__text">
      Powered by Unsplash, Pexels, Pixabay.<br />
      All images licensed under Creative Commons Zero.
    </p>
    <social-step-editor-sidebar-media-images-masonry
      :search="search"
      :image="image"
      :disabled="loading"
      @selected="onImageSelected"
    />
  </div>
</template>

<script>
import SharedStepEditorInputField from '../../shared/form/SharedStepEditorInputField';
import LoopSvg from '!!raw-loader!../../../../../../../assets/images/builders/loop.svg';
import SocialStepEditorSidebarMediaImagesMasonry from './SocialStepEditorSidebarMediaImagesMasonry';

export default {
  components: {
    SharedStepEditorInputField,
    SocialStepEditorSidebarMediaImagesMasonry,
  },
  props: {
    image: String,
  },
  data: () => ({
    search: '',
    loading: false,
    icon: LoopSvg,
  }),
  methods: {
    onSearch(val) {
      this.search = val;
    },
    onImageSelected(val) {
      this.$emit('update', val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.social-step-editor-sidebar-media-images {
  padding: 16px;
  width: 100%;
  &__text {
    text-align: center;
    color: $color-gunsmoke;
    font-size: 12px;
    line-height: 16px;
    margin: 16px 0;
  }
  &__icon {
    margin-left: 10px;
    color: inherit;
    display: flex;
  }
}
</style>
